// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '11754e53aa1f2558e9880bdc35321c15cbe1bd14';
export const BUILD_NUMBER = '272';
export const BUILD_TIMESTAMP = '2026-10-21T05:44:04.728Z';
